import React from "react";
import { Link } from "react-router-dom";

class FooterBottom extends React.Component {
  render() {
    return (
      <Link to="/" className="back_top">
        <i className="pe-7s-angle-up"> </i>
      </Link>
    );
  }
}

export default FooterBottom;



// WEBPACK FOOTER //
// ./src/layout/FooterBottom.js